// extracted by mini-css-extract-plugin
module.exports = {"box":"menu_box__12jR1","hr":"menu_hr__1Jtfb","hr_theme_light":"menu_hr_theme_light__P6WH8","hr_theme_dark":"menu_hr_theme_dark__zPWNo"};